import React from "react";
import LevelList from "../../components/level/LevelList";

const LevelsPage = () => {
    return <LevelList/>
}

export default LevelsPage;